import React, { useMemo, useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { formatDate } from "utils";

export default function AdminFormalityRequestLogItems({ items = [], columns = [] }) {
  const [selected, setSelected] = useState(null);

  // =========================
  // SORT
  // =========================
  const sortedItems = useMemo(() => {
    return [...items].sort(
      (a, b) => new Date(b.liCreatedAt) - new Date(a.liCreatedAt)
    );
  }, [items]);

  // =========================
  // BOOTSTRAP TOOLTIP INIT
  // =========================
  useEffect(() => {
    if (window.bootstrap) {
      const tooltipTriggerList = [].slice.call(
        document.querySelectorAll('[data-bs-toggle="tooltip"]')
      );
      tooltipTriggerList.forEach((el) => {
        new window.bootstrap.Tooltip(el);
      });
    }
  }, [sortedItems]);

  return (
    <>

      <div className="card mb-3">
        <div className="card-header">
          <strong>Historique</strong>
        </div>
        <div className="card-body p-0">

          <div className="table-responsive">
            <table className="table table-sm align-middle">

              <tbody>
                {sortedItems.map((item) => (
                  <tr key={item.liId} onClick={() => setSelected(item)}>
                    <td className="text-start">
                      <small>
                        {formatDate(item.liCreatedAt, 'd/m/Y H:i')}
                        <br />
                      </small>
                      {item.liMessage}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* =========================
           MODAL DETAIL
         ========================= */}
      <Modal
        show={!!selected}
        onHide={() => setSelected(null)}
        centered
      >
        {selected && (
          <>
            <Modal.Header closeButton>
              <Modal.Title>Détail de l'historique</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <div className="mb-2">
                <strong>Message :</strong>
                <div>{selected.liMessage}</div>
              </div>

              <div className="mb-2">
                <strong>Type :</strong>{" "}
                {selected.liRelatedType}
              </div>

              <div>
                <strong>Date :</strong>{" "}
                {formatDate(selected.liCreatedAt)}
              </div>
            </Modal.Body>
          </>
        )}
      </Modal>
    </>
  );
}